
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";

export const useNavbarState = () => {
  const [language, setLanguage] = useState<"pt" | "en">("pt");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const isMobile = useIsMobile();
  const location = useLocation();

  // Handle scroll detection
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when switching to desktop
  useEffect(() => {
    if (!isMobile && isMenuOpen) {
      setIsMenuOpen(false);
    }
  }, [isMobile, isMenuOpen]);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const handleLanguageChange = (lang: "pt" | "en") => {
    setLanguage(lang);
    // In a real app, this would update the i18n context
  };

  const menuItems = [
    { label: "Sobre nós", path: "/about" },
    { label: "Funcionalidades", path: "/features" },
    { label: "Para empresas", path: "/corporativo" }
  ];

  return {
    language,
    isMenuOpen,
    setIsMenuOpen,
    isScrolled,
    isMobileMenuOpen: isMenuOpen,
    setIsMobileMenuOpen: setIsMenuOpen,
    menuItems,
    isMobile,
    handleLanguageChange
  };
};

export default useNavbarState;
